import { render, staticRenderFns } from "./RegionAmountQuantitySalesCmp.vue?vue&type=template&id=114ea56c&"
import script from "./RegionAmountQuantitySalesCmp.vue?vue&type=script&lang=js&"
export * from "./RegionAmountQuantitySalesCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports